// removed by extract-text-webpack-plugin
module.exports = {"tooltip-size-control":"InlineTooltip__tooltip-size-control","tooltipSizeControl":"InlineTooltip__tooltip-size-control","tooltip-container":"InlineTooltip__tooltip-container","tooltipContainer":"InlineTooltip__tooltip-container","tooltip-content":"InlineTooltip__tooltip-content","tooltipContent":"InlineTooltip__tooltip-content"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/InlineTooltip/InlineTooltip.desktop.css
// module id = 1130
// module chunks = 8